import React, { useEffect, useState } from "react";
import { Button, Empty, message, Popconfirm, Table, Tooltip } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { LoadingOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { translate } from "../../locale";
import UserServices from "../../services/UserServices";
import { useParams } from "react-router-dom";

const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 24,
    }}
    spin
  />
);

const CoordinatorUsers = ({ reload }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
    if (reload > 0) {
      loadData();
    }
  }, [reload]);

  const loadData = async () => {
    setLoading(true);
    try {
      const response = await UserServices.getManagement(id);
      if (response.status >= 200 && response.status < 300) {
        setData(response.data.management);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleDelete = async (data) => {
    setLoading(true);
    try {
      const response = await UserServices.deleteManagement(data.id);
      if (response.status >= 200 && response.status < 300) {
        message.success(
          translate(
            "El {0} se guardó exitosamente.",
            translate("usuario administrador")
          )
        );
        loadData();
      } else {
        message.error(response.data.message);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      message.error(e.message);
      setLoading(false);
    }
  };

  const handleDownGrade = async (data) => {
    setLoading(true);
    try {
      /* const response = await UserServices.deleteManagement(data.id);
      if (response.status >= 200 && response.status < 300) {
        message.success(
          translate(
            "El {0} se guardó exitosamente.",
            translate("usuario administrador")
          )
        );
        loadData();
      } else {
        message.error(response.data.message);
      } */
      console.log("handleDownGrade", data);
      setLoading(false);
    } catch (e) {
      console.log(e);
      message.error(e.message);
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-4 justify-center">
          <Popconfirm
            title={translate("¿Estás seguro de eliminar el registro?")}
            okText={translate("Si")}
            cancelText={translate("No")}
            onConfirm={() => handleDelete(record)}
          >
            <Button
              type="text"
              icon={<DeleteOutlined />}
              size="small"
              className="border-0"
            />
          </Popconfirm>
          <Popconfirm
            title={
              <div className="text-center">
                {translate(`¿Esta seguro que desea cambiar el rol de`)}
                <br />
                {record.manager.full_name}
                <br />
                {translate(`de coordinador a administrador?`)}
              </div>
            }
            okText={translate("Si")}
            cancelText={translate("No")}
            onConfirm={() => handleDownGrade(record)}
          >
            <Tooltip title={translate("Cambiar a administrador")}>
              <Button
                type="text"
                icon={<UserSwitchOutlined />}
                size="small"
                className="border-0"
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
      width: 100,
    },
    {
      title: translate("Usuario"),
      dataIndex: "username",
      key: "username",
      render: (_, record) => record.manager.username,
      sorter: (a, b) => {
        if (a.manager.username < b.manager.username) return -1;
        if (a.manager.username > b.manager.username) return 1;
        return 0;
      },
    },
    {
      title: translate("Nombre Completo"),
      dataIndex: "full_name",
      key: "full_name",
      render: (_, record) => record.manager.full_name,
      sorter: (a, b) => {
        if (a.manager.full_name < b.manager.full_name) return -1;
        if (a.manager.full_name > b.manager.full_name) return 1;
        return 0;
      },
    },
  ];
  return (
    <Table
      rowKey={(i) => i.id}
      dataSource={data}
      columns={columns}
      loading={
        loading ? { indicator: antIcon, className: "text-custom_blue" } : false
      }
      locale={{
        emptyText: <Empty description={translate("No hay datos")} />,
        sortTitle: translate("Ordenar"),
        triggerDesc: translate("Ordenar (descendente)"),
        triggerAsc: translate("Ordenar (ascendente)"),
        cancelSort: translate("Cancelar orden"),
      }}
    />
  );
};

export default CoordinatorUsers;
